
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SUCCESS_POPUP_TYPE } from "@/constants/popupTypes";

import PICTURE_1 from "@/assets/images/V2/bn-popup-line-1.png";
import PICTURE_2 from "@/assets/images/V2/bn-popup-line-2.png";

@Component
export default class SubmitRequestVisaPopUp extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: SUCCESS_POPUP_TYPE }) readonly type!: string;

  PICTURE_1 = PICTURE_1;
  PICTURE_2 = PICTURE_2;

  showPopup = false;

  // TODO: Refactor it, after refactoring "Nb-dialog" component;
  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;

    this.$emit("open");
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  mounted() {
    this.$root.$on("open-submit-request-visa-popup", () => {
      this.open();
    });
  }
}
